import { useMutation } from "react-query";
import { deleteLE } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

const useDeactivateLicenseE = () => {
  return useMutation(deleteLE);
};
export default useDeactivateLicenseE;
